// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3H7PP","balanceDisclaimer":"posDashboard_balanceDisclaimer__1tXxH"};